import { MoveableOverlay } from "./MoveableOverlay";

export class MoveableOverlayStockImage extends MoveableOverlay {

	type: string = "stock";

	file: any;

	constructor(variationId: string, twinnedId: string) {
		super(variationId, twinnedId);

		this.file = null;

		/* 		this.moveableObject = {
					draggable: true,
					throttleDrag: 0,
					resizable: false,
					throttleResize: 1,
					keepRatio: true,
					scalable: true,
					throttleScale: 1,
					rotatable: true,
					throttleRotate: 0,
					pinchable: true, // ["draggable", "resizable", "scalable", "rotatable"]
					origin: false,
					snappable: true,
					snapVertical: true,
					snapHorizontal: true,
					snapElement: true,
					snapThreshold: 0,
					snapCenter: true,
				};
				this.moveabaleStyle = {
					width: "23%",
					//height: "30%",
					left: "5%",
					top: "5%",
					//right: 0,
					//bottom: 0,
					position: "absolute",
					userSelect: "none"
				}; */
	}

	copyProperties(overlayToCopy: MoveableOverlayStockImage) {
		super.copyProperties(overlayToCopy);
		this.file = JSON.parse(JSON.stringify(overlayToCopy.file));
	}

	copy(): MoveableOverlayStockImage {
		let copy = new MoveableOverlayStockImage(this.variationId, this.twinnedId);

		copy.copyProperties(this);
		return copy;
	}

	static copyFromParsed(parsedObject: any): MoveableOverlayStockImage {
		let copy = new MoveableOverlayStockImage(parsedObject.variationId, parsedObject.twinnedId ? parsedObject.twinnedId : null);

		copy.copyProperties(parsedObject);
		return copy;
	}

	getOverlayXYWH(videoPreviewPixelsWidth, outerVideoResolutionX, videoScale, currentSize) {
		if (this.position === '' || !this.file) {
			return null;
		}

		let width = outerVideoResolutionX;
		let p = width / videoPreviewPixelsWidth;
		let k = p * videoScale;

		let overlayCenterXY = this.getOverlayCenterXY(videoPreviewPixelsWidth, currentSize);
		let tx = overlayCenterXY.x * k;
		let ty = overlayCenterXY.y * k;
		let w = this.offsetDimensions.width * k * this.transforms.scaleX;
		let h = this.offsetDimensions.height * k * this.transforms.scaleX;

		return {
			x: tx,
			y: ty,
			w: w,
			h: h
		};
	}
}